import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { DecedatiService } from '../decedati.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { Decedat } from '../decedati.interface';

@Component({
    selector: 'app-edit-decedati',
    templateUrl: './edit-decedati.component.html',
    styleUrls: ['./edit-decedati.component.scss']
})
export class EditDecedatiComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        first_name: new FormControl(this.data.first_name, [Validators.required]),
        last_name: new FormControl(this.data.last_name, [Validators.required]),
        cnp: new FormControl(this.data.cnp, [Validators.required]),
        cert_number: new FormControl(this.data.cert_number, [Validators.required]),
        cert_date: new FormControl(this.formatDate(this.data.cert_date), [Validators.required]),
        obs: new FormControl(this.data.obs),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditDecedatiComponent>,
        private decedatiService: DecedatiService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    formatDate(dateString: string): Date | null {
        if (!dateString) {
            return null;
        }

        // Separă data în zi, lună, an
        const parts = dateString.split('/');

        if (parts.length !== 3) {
            return null;
        }

        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Luna în JavaScript este 0-indexed
        const year = parseInt(parts[2], 10);

        // Creează obiectul Date
        return new Date(year, month, day);
    }

    submitForm() {
        this.isLoading = true;

        const payload: Decedat = {
            first_name: this.form.get('first_name')?.value,
            last_name: this.form.get('last_name')?.value,
            cnp: this.form.get('cnp')?.value,
            cert_number: this.form.get('cert_number')?.value,
            cert_date: this.form.get('cert_date')?.value,
            obs: this.form.get('obs')?.value,
        };

        this.decedatiService
            .updateDecedati(payload, this.data.id)
            .pipe(finalize(() => this.isLoading = false))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true })
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }
}
